export default {
  operator: 'default',
  impc: 'impc',
};
